import(/* webpackMode: "eager" */ "/Users/benawad/Documents/programming/VoidPulse/web/src/app/page.tsx");
